module.exports = __webpack_public_path__ + "static/media/platformpage-5.fdc67130.png";